import $ from "jquery";
import { activateDescriptions } from "./Service/ServiceFunctions";

(() => {
  $("[data-info-description]").each((idx, item) => {
    activateDescriptions($(item));
  });
})();
